import React from 'react';
import MatClntCoreTransactionList from './MatClntCoreTransactionList';

export default function MatClntIssueList() {
  return (
    <MatClntCoreTransactionList
      title="Client Material - Issue Transactions"
      opTypes={["issue"]}
    />
  );
}
